import { CircularProgress } from "@mui/material"

const FullPageLoading = () => {
  return (
    <>
      <div className="h-screen flex justify-center items-center m-4">
        <CircularProgress />
      </div>
    </>
  )
}

export default FullPageLoading
